var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",class:( _obj = {}, _obj[("bg-" + _vm.type)] = _vm.type, _obj ),staticStyle:{"background-image":"url('assets/img/pexels-tousif-khan-814667.jpg')","background-repeat":"no-repeat","background-size":"cover","background-position":"center center"}},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"header-body"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }